// extracted by mini-css-extract-plugin
export var details = "_lq-0";
export var inspectorPopover = "_lq-1";